/* ==========================================================================
   PDP Add-ons – Leinenweberei Hoffmann
   Block „Veredelung (optional)" + Block „Wird oft zusammen gekauft" (Bundle).
   Läuft additiv NACH assets/pdp.js: Summe/CTA, Multi-Line-Item-Warenkorb,
   Farb-Swatches + dynamisches Vorschaubild, Info-Popups (am <body>).
   ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    var euros = cents / 100;
    if (cents % 100 === 0) {
      return euros.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }
    return euros.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
  }

  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function initAddons(root) {
    if (!root || root.dataset.pdpAddonsInit) return;
    var mainCfg = readJSON(root.querySelector('[data-pdp-config]'));
    if (!mainCfg) return;

    var verWrap = root.querySelector('[data-pdp-veredelung]');
    var bundleWrap = root.querySelector('[data-pdp-bundle]');
    var wpWrap = root.querySelector('[data-pdp-wpartner]');
    if (!verWrap && !bundleWrap && !wpWrap) return;
    root.dataset.pdpAddonsInit = '1';

    var verCfg = readJSON(root.querySelector('[data-pdp-veredelung-config]'));
    var bundleCfg = readJSON(root.querySelector('[data-pdp-bundle-config]'));
    var wpCfg = readJSON(root.querySelector('[data-pdp-wpartner-config]'));

    var optionCount = mainCfg.optionCount || 1;
    var sizePositions = mainCfg.sizePositions || [];
    var variants = mainCfg.variants || [];
    var formId = mainCfg.formId;
    var form = document.getElementById(formId);
    var totalEl = root.querySelector('[data-pdp-total]');
    var ctaButton = root.querySelector('[data-product-add-to-cart-button]');
    var ctaLabelEl = root.querySelector('[data-pdp-cta-label]');
    var qtyInput = document.querySelector('input[name="quantity"][form="' + formId + '"]') ||
      root.querySelector('input[name="quantity"]');
    var h1 = root.querySelector('.pdp-buybox h1');
    var mainTitle = h1 ? h1.textContent.trim() : '';

    function selMainOpts() {
      var o = [];
      for (var i = 1; i <= optionCount; i++) {
        var c = root.querySelector('input[name="option' + i + '"]:checked');
        if (c) { o.push(c.value); continue; }
        var s = root.querySelector('select[name="option' + i + '"]');
        o.push(s ? s.value : null);
      }
      return o;
    }
    function findMainVariant(opts) {
      for (var v = 0; v < variants.length; v++) {
        var m = true;
        for (var i = 0; i < optionCount; i++) {
          if (opts[i] != null && variants[v].options[i] !== opts[i]) { m = false; break; }
        }
        if (m) return variants[v];
      }
      return null;
    }
    function sizeValues(opts) { return sizePositions.map(function (p) { return opts[p - 1]; }); }
    function colorValue(opts) {
      for (var i = 1; i <= optionCount; i++) { if (sizePositions.indexOf(i) === -1) return opts[i - 1]; }
      return null;
    }

    /* ---------- Veredelung ---------- */
    var verState = {};
    function resolveVer(item, sizeVals) {
      var vs = item.variants || [];
      if (vs.length === 0) return null;
      if (vs.length === 1) return vs[0];
      for (var i = 0; i < vs.length; i++) {
        for (var j = 0; j < sizeVals.length; j++) {
          if (sizeVals[j] != null && vs[i].options.indexOf(sizeVals[j]) !== -1) return vs[i];
        }
      }
      return null;
    }

    if (verWrap) {
      /* Popups ans <body> hängen, damit sie über allen Sektionen/Stacking-Contexts liegen */
      root.querySelectorAll('[data-pdp-ver-popup]').forEach(function (pop) {
        document.body.appendChild(pop);
        pop.addEventListener('click', function (e) {
          if (e.target.hasAttribute('data-pdp-ver-popup-close') || e.target.closest('[data-pdp-ver-popup-close]')) {
            pop.hidden = true; document.documentElement.style.overflow = '';
          }
        });
      });
      root.querySelectorAll('[data-pdp-ver-info]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var pop = document.querySelector('[data-pdp-ver-popup="' + btn.getAttribute('data-pdp-ver-info') + '"]');
          if (pop) { pop.hidden = false; document.documentElement.style.overflow = 'hidden'; }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('[data-pdp-ver-popup]:not([hidden])').forEach(function (p) {
            p.hidden = true; document.documentElement.style.overflow = '';
          });
        }
      });
      root.querySelectorAll('[data-pdp-ver-check]').forEach(function (chk) {
        chk.addEventListener('change', function () {
          var ini = root.querySelector('[data-pdp-ver-initials="' + chk.value + '"]');
          if (ini) ini.hidden = !chk.checked;
          recalc();
        });
      });
      root.querySelectorAll('[data-pdp-ver-initials-input]').forEach(function (inp) {
        inp.addEventListener('input', function () { inp.value = inp.value.toUpperCase(); });
      });
    }

    /* ---------- Bundle ---------- */
    var bundleSel = {};
    var bundleChecked = false;
    if (bundleWrap && bundleCfg && bundleCfg.partner) {
      var partner = bundleCfg.partner;
      var check = root.querySelector('[data-pdp-bundle-check]');
      var panel = root.querySelector('[data-pdp-bundle-panel]');
      var card = root.querySelector('[data-pdp-bundle-card]');
      var bundleImg = root.querySelector('[data-pdp-bundle-img]');

      var bundleColorPos = null;
      partner.options.forEach(function (o) { if (/farbe|color|colour/i.test(o.name)) bundleColorPos = o.position; });

      var optionValues = function (pos) {
        for (var i = 0; i < partner.options.length; i++) { if (partner.options[i].position === pos) return partner.options[i].values; }
        return [];
      };
      var partnerVariant = function () {
        for (var v = 0; v < partner.variants.length; v++) {
          var m = true;
          for (var pi = 0; pi < partner.options.length; pi++) {
            var pos = partner.options[pi].position;
            if (partner.variants[v].options[pos - 1] !== bundleSel[pos]) { m = false; break; }
          }
          if (m) return partner.variants[v];
        }
        return null;
      };
      var ensureAvailable = function () {
        var v = partnerVariant();
        if (v && v.available) return;
        var col = bundleColorPos != null ? bundleSel[bundleColorPos] : null;
        var pick = null;
        for (var i = 0; i < partner.variants.length; i++) {
          var vr = partner.variants[i];
          if (!vr.available) continue;
          if (col != null && bundleColorPos != null && vr.options[bundleColorPos - 1] !== col) continue;
          pick = vr; break;
        }
        if (!pick) { for (var j = 0; j < partner.variants.length; j++) { if (partner.variants[j].available) { pick = partner.variants[j]; break; } } }
        if (pick) { partner.options.forEach(function (o) { bundleSel[o.position] = pick.options[o.position - 1]; }); }
      };
      var updateImg = function () {
        if (!bundleImg) return;
        var src = null;
        var pv = partnerVariant();
        if (pv && pv.image) src = pv.image;
        if (!src && bundleColorPos != null) {
          var col = bundleSel[bundleColorPos];
          for (var i = 0; i < partner.variants.length; i++) {
            if (partner.variants[i].options[bundleColorPos - 1] === col && partner.variants[i].image) { src = partner.variants[i].image; break; }
          }
        }
        if (!src) src = partner.image;
        if (src && bundleImg.getAttribute('src') !== src) bundleImg.src = src;
      };
      var initBundleSelection = function () {
        var mainColor = colorValue(selMainOpts());
        partner.options.forEach(function (o) {
          var chosen = null;
          if (mainColor && o.values.indexOf(mainColor) !== -1 && /farbe|color|colour/i.test(o.name)) chosen = mainColor;
          if (!chosen) chosen = o.values[0];
          bundleSel[o.position] = chosen;
        });
        ensureAvailable();
      };
      var renderChips = function () {
        root.querySelectorAll('[data-pdp-bundle-chip]').forEach(function (chip) {
          var pos = parseInt(chip.getAttribute('data-opt-position'), 10);
          var val = chip.getAttribute('data-value');
          chip.classList.toggle('is-selected', bundleSel[pos] === val);
          var avail = partner.variants.some(function (vr) {
            if (!vr.available) return false;
            if (vr.options[pos - 1] !== val) return false;
            for (var pi = 0; pi < partner.options.length; pi++) {
              var p2 = partner.options[pi].position;
              if (p2 === pos) continue;
              if (vr.options[p2 - 1] !== bundleSel[p2]) return false;
            }
            return true;
          });
          chip.classList.toggle('is-unavailable', !avail);
        });
        root.querySelectorAll('[data-pdp-bundle-opt]').forEach(function (o) {
          var pos = parseInt(o.getAttribute('data-opt-position'), 10);
          var vspan = o.querySelector('[data-pdp-bundle-opt-value]');
          if (vspan) vspan.textContent = bundleSel[pos] || '';
        });
        updateImg();
      };
      var syncColor = function () {
        if (bundleColorPos == null) return;
        var mc = colorValue(selMainOpts());
        if (!mc) return;
        if (optionValues(bundleColorPos).indexOf(mc) !== -1) {
          bundleSel[bundleColorPos] = mc;
          ensureAvailable();
          renderChips();
        }
      };
      root.querySelectorAll('[data-pdp-bundle-chip]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          bundleSel[parseInt(chip.getAttribute('data-opt-position'), 10)] = chip.getAttribute('data-value');
          ensureAvailable();
          renderChips(); recalc();
        });
      });
      if (check) {
        check.addEventListener('change', function () {
          bundleChecked = check.checked;
          if (panel) panel.hidden = !bundleChecked;
          if (card) card.classList.toggle('is-checked', bundleChecked);
          recalc();
        });
      }
      root._pdpBundle = { syncColor: syncColor, renderChips: renderChips, updateImg: updateImg, variant: partnerVariant };
      initBundleSelection();
      renderChips();
    }

    /* ---------- Wende-Partner: „Passenden Bezug mitbestellen" ----------
       Erscheint erst, wenn im Konfigurator beide Seiten gewählt sind (Event wende:change).
       Stoffkombination + Stoffe (Seite A/B) werden vom Hauptprodukt geerbt, der Kunde wählt
       nur Größe + Knopfleiste. Kein Rabatt – der reguläre Variantenpreis. */
    var wpSel = { size: null, knopf: 'fuss' };
    var wpChecked = false;
    var wpKnopfTouched = false;
    var wpInherit = { combo: null, seiteA: null, seiteB: null, knopfSeiteLabel: null };

    if (wpWrap && wpCfg && wpCfg.variants) {
      var wpCheck = root.querySelector('[data-pdp-wpartner-check]');
      var wpPanel = root.querySelector('[data-pdp-wpartner-panel]');
      var wpCard = root.querySelector('[data-pdp-wpartner-card]');

      var wpSizeAvailable = function (size) {
        for (var i = 0; i < wpCfg.variants.length; i++) {
          var v = wpCfg.variants[i];
          if (v.options[wpCfg.sizePos - 1] === size &&
              v.options[wpCfg.comboPos - 1] === wpInherit.combo && v.available) return true;
        }
        return false;
      };
      var wpFirstSize = function () {
        /* Vorauswahl bevorzugt die hinterlegten Standardgrößen (top_groessen), damit der
           angezeigte Preis und der Ein-Klick-Kauf auf der häufigsten Größe stehen. */
        var tops = wpCfg.topSizes || [];
        for (var t = 0; t < tops.length; t++) { if (wpSizeAvailable(tops[t])) return tops[t]; }
        for (var i = 0; i < wpCfg.sizes.length; i++) { if (wpSizeAvailable(wpCfg.sizes[i])) return wpCfg.sizes[i]; }
        return null;
      };
      var wpVariant = function () {
        if (!wpInherit.combo || !wpSel.size) return null;
        for (var i = 0; i < wpCfg.variants.length; i++) {
          var v = wpCfg.variants[i];
          if (v.options[wpCfg.comboPos - 1] === wpInherit.combo && v.options[wpCfg.sizePos - 1] === wpSel.size) return v;
        }
        return null;
      };
      var wpComboOffered = function () {
        if (!wpInherit.combo) return true;
        return wpCfg.variants.some(function (v) { return v.options[wpCfg.comboPos - 1] === wpInherit.combo; });
      };
      var renderWp = function () {
        root.querySelectorAll('[data-pdp-wpartner-size]').forEach(function (chip) {
          var val = chip.getAttribute('data-value');
          chip.classList.toggle('is-selected', wpSel.size === val);
          chip.classList.toggle('is-unavailable', wpInherit.combo ? !wpSizeAvailable(val) : false);
        });
        var sv = root.querySelector('[data-pdp-wpartner-size-value]');
        if (sv) sv.textContent = wpSel.size || '';
        root.querySelectorAll('[data-pdp-wpartner-knopf]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-pdp-wpartner-knopf') === wpSel.knopf);
        });
        var priceEl = root.querySelector('[data-pdp-wpartner-price]');
        var v = wpVariant();
        if (priceEl) {
          if (v && v.available) priceEl.textContent = '+ ' + money(v.price);
          else if (wpInherit.combo && wpSel.size) priceEl.textContent = 'derzeit nicht verfügbar';
          else priceEl.textContent = '';
        }
        var notice = root.querySelector('[data-pdp-wpartner-notice]');
        if (notice) {
          if (wpInherit.combo && !wpComboOffered()) {
            notice.hidden = false;
            notice.textContent = 'Diese Stoffkombination gibt es beim passenden Bezug leider nicht.';
          } else { notice.hidden = true; }
        }
      };
      root.querySelectorAll('[data-pdp-wpartner-size]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.classList.contains('is-unavailable')) return;
          wpSel.size = chip.getAttribute('data-value');
          renderWp(); recalc();
        });
      });
      root.querySelectorAll('[data-pdp-wpartner-knopf]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wpSel.knopf = btn.getAttribute('data-pdp-wpartner-knopf');
          wpKnopfTouched = true;
          renderWp(); recalc();
        });
      });
      if (wpCheck) {
        wpCheck.addEventListener('change', function () {
          wpChecked = wpCheck.checked;
          if (wpPanel) wpPanel.hidden = !wpChecked;
          if (wpCard) wpCard.classList.toggle('is-checked', wpChecked);
          recalc();
        });
      }

      /* „Weitere Größen" ein-/ausklappen */
      var wpMoreToggle = root.querySelector('[data-pdp-wpartner-size-toggle]');
      var wpMoreBox = root.querySelector('[data-pdp-wpartner-more]');
      if (wpMoreToggle && wpMoreBox) {
        wpMoreToggle.addEventListener('click', function () {
          var willOpen = wpMoreBox.hasAttribute('hidden');
          if (willOpen) wpMoreBox.removeAttribute('hidden'); else wpMoreBox.setAttribute('hidden', '');
          wpMoreToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          wpMoreToggle.textContent = willOpen
            ? '− Weitere Größen einklappen'
            : wpMoreToggle.getAttribute('data-label-closed');
        });
      }

      /* Eigene Größentabelle (Partner) – öffnen/schließen. Bewusst NICHT über pdp.js:
         das steuert nur die Haupt-Tabelle [data-pdp-advisor]. Der Ablauf ist sonst
         Zeile für Zeile derselbe wie openAdvisor/closeAdvisor in assets/pdp.js:
         Fokus merken, Klasse is-open, Seiten-Scroll sperren, Fokus auf den
         Schließen-Knopf – und zurück beim Schließen. Drei Schließwege: Klick auf den
         Overlay-Hintergrund, Klick auf [data-pdp-wpartner-advisor-close], Escape.

         HOFFMANN 18.08.2026: Unter 1000 px liegt diese Tabelle über dem Bottom-Sheet
         des Wende-Konfigurators (snippets/pdp-wende-mobile-1). Dessen Escape-Handler
         hängt ebenfalls am document und wird – weil diese Datei mit defer früher
         läuft als pdp-wende.js – NACH diesem hier aufgerufen. Ohne Abbruch würde er
         das Sheet schließen, während hier nur die Tabelle zugeht. Deshalb bricht der
         Escape-Handler die Weiterleitung hart ab, sobald die Tabelle offen ist; das
         Sheet prüft zusätzlich auf .is-open, falls sich die Ladereihenfolge ändert. */
      var wpAdvisor = root.querySelector('[data-pdp-wpartner-advisor]');
      if (wpAdvisor) {
        var wpAdvLast = null;
        var wpAdvOpen = function () {
          wpAdvLast = document.activeElement;
          wpAdvisor.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
          var c = wpAdvisor.querySelector('[data-pdp-wpartner-advisor-close]');
          if (c) c.focus();
        };
        var wpAdvClose = function () {
          wpAdvisor.classList.remove('is-open');
          document.documentElement.style.overflow = '';
          if (wpAdvLast && wpAdvLast.focus) wpAdvLast.focus();
        };
        root.querySelectorAll('[data-pdp-wpartner-advisor-open]').forEach(function (b) {
          b.addEventListener('click', wpAdvOpen);
        });
        wpAdvisor.addEventListener('click', function (e) {
          if (e.target === wpAdvisor || (e.target.closest && e.target.closest('[data-pdp-wpartner-advisor-close]'))) wpAdvClose();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape' || !wpAdvisor.classList.contains('is-open')) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          wpAdvClose();
        });
      }

      var wpSyncFromWende = function (d) {
        wpInherit.combo = d.combo || null;
        wpInherit.seiteA = d.seiteA || null;
        wpInherit.seiteB = d.seiteB || null;
        wpInherit.knopfSeiteLabel = d.knopfSeiteLabel || null;
        if (!wpKnopfTouched) {
          if (d.knopf === 'hotel' || d.knopfLabel === 'Hochgesetzt') wpSel.knopf = 'hotel';
          else wpSel.knopf = 'fuss';
        }
        if (wpInherit.combo && (!wpSel.size || !wpSizeAvailable(wpSel.size))) wpSel.size = wpFirstSize();
        if (d.bothChosen) {
          wpWrap.removeAttribute('hidden');
        } else {
          wpWrap.setAttribute('hidden', '');
          if (wpCheck && wpCheck.checked) { wpCheck.checked = false; wpChecked = false; if (wpPanel) wpPanel.hidden = true; if (wpCard) wpCard.classList.remove('is-checked'); }
        }
        renderWp(); recalc();
      };

      document.addEventListener('wende:change', function (e) { wpSyncFromWende(e.detail || {}); });

      /* Startzustand direkt aus den Konfigurator-Feldern lesen – das erste wende:change kann
         gefeuert haben, bevor dieser Listener stand (pdp-wende.js läuft mit defer vor uns). */
      (function () {
        var aEl = document.querySelector('[data-pdp-wende-prop="A"]');
        var bEl = document.querySelector('[data-pdp-wende-prop="B"]');
        var kEl = document.querySelector('[data-pdp-wende-prop="knopf"]');
        var ksEl = document.querySelector('[data-pdp-wende-prop="knopfseite"]');
        var comboEl = root.querySelector('input[name="option1"]:checked') || root.querySelector('select[name="option1"]');
        wpSyncFromWende({
          combo: comboEl ? comboEl.value : null,
          seiteA: (aEl && !aEl.disabled) ? aEl.value : null,
          seiteB: (bEl && !bEl.disabled) ? bEl.value : null,
          knopfLabel: (kEl && !kEl.disabled) ? kEl.value : null,
          knopf: (kEl && kEl.value === 'Hochgesetzt') ? 'hotel' : 'fuss',
          knopfSeiteLabel: (ksEl && !ksEl.disabled) ? ksEl.value : null,
          bothChosen: !!(aEl && !aEl.disabled && aEl.value && bEl && !bEl.disabled && bEl.value)
        });
      })();
    }

    /* ---------- Summe + Zeilenpreise ---------- */
    function recalc() {
      var opts = selMainOpts();
      var mainVar = findMainVariant(opts);
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var base = mainVar ? mainVar.price * qty : 0;
      var addon = 0;
      var sizeVals = sizeValues(opts);

      if (verWrap && verCfg && verCfg.items) {
        var anyCustomVer = false;
        verCfg.items.forEach(function (item) {
          var row = root.querySelector('[data-pdp-ver-row][data-ver-id="' + item.id + '"]');
          var chk = root.querySelector('[data-pdp-ver-check][value="' + item.id + '"]');
          var priceEl = row ? row.querySelector('[data-pdp-ver-price]') : null;
          var v = resolveVer(item, sizeVals);
          verState[item.id] = { variant: v };
          if (!v || !v.available) {
            if (row) row.classList.add('is-disabled');
            if (chk) {
              chk.disabled = true;
              if (chk.checked) {
                chk.checked = false;
                var ini = root.querySelector('[data-pdp-ver-initials="' + item.id + '"]');
                if (ini) ini.hidden = true;
              }
            }
            if (priceEl) priceEl.textContent = 'nicht verfügbar';
          } else {
            if (row) row.classList.remove('is-disabled');
            if (chk) chk.disabled = false;
            if (priceEl) priceEl.textContent = '+ ' + money(v.price);
            if (chk && chk.checked) { addon += v.price * qty; anyCustomVer = true; }
          }
        });
        var notice = root.querySelector('[data-pdp-ver-notice]');
        if (notice) notice.hidden = !anyCustomVer;
      }

      if (bundleWrap && bundleCfg && bundleCfg.partner) {
        var p = bundleCfg.partner;
        var pct = bundleCfg.discountPercent || 5;
        var pv = null;
        for (var v2 = 0; v2 < p.variants.length; v2++) {
          var m = true;
          for (var pi = 0; pi < p.options.length; pi++) {
            var pos = p.options[pi].position;
            if (p.variants[v2].options[pos - 1] !== bundleSel[pos]) { m = false; break; }
          }
          if (m) { pv = p.variants[v2]; break; }
        }
        var priceLine = root.querySelector('[data-pdp-bundle-price]');
        if (pv) {
          var save = Math.round(pv.price * pct / 100);
          var setP = pv.price - save;
          if (priceLine) {
            priceLine.innerHTML = 'Im Set nur <strong>' + money(setP) + '</strong> <s>' + money(pv.price) +
              '</s> <span class="pdp-bundle__save">– Sie sparen ' + money(save) + '</span>';
          }
          if (bundleChecked) addon += setP;
        } else if (priceLine) {
          priceLine.textContent = 'Diese Kombination ist nicht verfügbar.';
        }
      }

      if (wpWrap && wpCfg && typeof wpVariant === 'function') {
        var wv = wpVariant();
        if (wpChecked && wv && wv.available) addon += wv.price;
      }

      var total = base + addon;
      if (totalEl) totalEl.textContent = money(total);
      if (ctaButton) {
        var lbl = ctaLabelEl ? ctaLabelEl.textContent : '';
        ctaButton.setAttribute('data-button-content', lbl + ' · ' + money(total));
      }
    }

    function onMainChange() {
      if (root._pdpBundle && root._pdpBundle.syncColor) root._pdpBundle.syncColor();
      recalc();
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[name^="option"], select[name^="option"]')) onMainChange();
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', recalc);
      var qw = qtyInput.closest('quantity-selector');
      if (qw) qw.addEventListener('click', function () { setTimeout(recalc, 0); });
    }
    document.addEventListener('variant:changed', function () { setTimeout(onMainChange, 0); });

    /* ---------- Add-to-Cart mit mehreren Line-Items ---------- */
    if (ctaButton && form) {
      ctaButton.addEventListener('click', function (e) {
        var groupId = 'pdpg_' + Date.now();
        var opts = selMainOpts();
        var mainVar = findMainVariant(opts);
        var hiddenId = form.querySelector('input[name="id"]');
        var mainId = (hiddenId && hiddenId.value) ? hiddenId.value : (mainVar ? mainVar.id : null);
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

        var selVers = [];
        if (verWrap && verCfg && verCfg.items) {
          verCfg.items.forEach(function (item) {
            var chk = root.querySelector('[data-pdp-ver-check][value="' + item.id + '"]');
            if (chk && chk.checked && !chk.disabled) {
              var st = verState[item.id];
              if (st && st.variant) {
                var props = { '_veredelung_fuer': groupId, 'Veredelung für': mainTitle };
                var iniInput = root.querySelector('[data-pdp-ver-initials="' + item.id + '"] [data-pdp-ver-initials-input]');
                if (iniInput && iniInput.value.trim()) props['Initialen'] = iniInput.value.trim();
                selVers.push({ id: st.variant.id, quantity: qty, properties: props });
              }
            }
          });
        }

        var bundleItem = null;
        if (bundleWrap && bundleChecked && bundleCfg && bundleCfg.partner) {
          var p = bundleCfg.partner, pv = null;
          for (var v = 0; v < p.variants.length; v++) {
            var m = true;
            for (var pi = 0; pi < p.options.length; pi++) {
              var pos = p.options[pi].position;
              if (p.variants[v].options[pos - 1] !== bundleSel[pos]) { m = false; break; }
            }
            if (m) { pv = p.variants[v]; break; }
          }
          if (pv && pv.available) bundleItem = { id: pv.id, quantity: 1, properties: { '_bundle_mit': groupId, 'Im Set mit': mainTitle } };
        }

        var wpItem = null;
        if (wpWrap && wpChecked && wpCfg && typeof wpVariant === 'function') {
          var wpv = wpVariant();
          if (wpv && wpv.available) {
            var wprops = { '_wende_set': groupId, 'Passend zu': mainTitle };
            if (wpInherit.seiteA) wprops['Seite A'] = wpInherit.seiteA;
            if (wpInherit.seiteB) wprops['Seite B'] = wpInherit.seiteB;
            wprops['Knopfleiste'] = (wpSel.knopf === 'hotel') ? 'Hochgesetzt' : (wpCfg.knopfFussLabel || 'Am Fußende');
            /* HOFFMANN 09.08.2026: Die Seitenangabe kommt jetzt in beiden Macharten vom
               Hauptprodukt. Der Feldname unterscheidet sich, damit in JTL eindeutig ist,
               ob die Knopfleiste auf der Flaeche liegt oder nur die Knoepfe sichtbar sind. */
            if (wpInherit.knopfSeiteLabel) {
              wprops[(wpSel.knopf === 'hotel') ? 'Knopfleiste auf Seite' : 'Knöpfe sichtbar auf Seite'] = wpInherit.knopfSeiteLabel;
            }
            wpItem = { id: wpv.id, quantity: 1, properties: wprops };
          }
        }

        if (!selVers.length && !bundleItem && !wpItem) return;

        e.preventDefault(); e.stopImmediatePropagation();

        var mainProps = {};
        form.querySelectorAll('[name^="properties["]').forEach(function (el) {
          var mm = el.name.match(/^properties\[(.+)\]$/);
          if (mm && el.value && el.value.trim()) mainProps[mm[1]] = el.value;
        });
        mainProps['_ref'] = groupId;

        var items = [{ id: mainId, quantity: qty, properties: mainProps }];
        selVers.forEach(function (it) { items.push(it); });
        if (bundleItem) items.push(bundleItem);
        if (wpItem) items.push(wpItem);

        ctaButton.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          window.location.href = '/cart';
        }).catch(function () {
          ctaButton.removeAttribute('disabled');
          window.alert('Es gab ein Problem beim Hinzufügen zum Warenkorb. Bitte versuchen Sie es erneut.');
        });
      }, true);
    }

    recalc();
  }

  function boot() { document.querySelectorAll('[data-pdp-main]').forEach(initAddons); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
